import {useQuery} from "@tanstack/react-query";

import {ParamsOptions, QueryOptions} from "@/src/modules/core/types";

import {shiftsService} from "../services";

export default function useShifts(_options = {} as ParamsOptions, queryOptions: QueryOptions = {}) {
  const options = {..._options};

  const query = useQuery({
    queryKey: queryOptions.queryKey ?? ["shifts", options],
    queryFn: () => shiftsService.getShifts(options),
    gcTime: 0,
    refetchOnWindowFocus: (queryOptions.refetchOnWindowFocus as boolean) ?? false,
    staleTime: (queryOptions?.staleTime as number) ?? 0,
    enabled: (queryOptions as {enabled?: boolean}).enabled ?? true,
  });

  const data = query.isSuccess ? (query.data?.shifts ?? []) : [];
  const total = query.isSuccess ? (query.data?.meta?.total ?? 0) : 0;

  return {...query, shifts: data, total};
}
